//
//
//
//
//

export default {
name: "CompanyFounderEdit"
}
